import React from "react";

const LightEye = (props) => {
	return (
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fal"
			data-icon="eye"
			className="svg-inline--fa fa-eye fa-w-18"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 576 512"
			{...props}
		>
			<path
				fill="currentColor"
				d="M288 288a64 64 0 0 0 0-128c-1 0-1.9 .2-2.9 .3a47.5 47.5 0 0 1 -60.9 60.9c0 1-.3 1.9-.3 2.9a64 64 0 0 0 64 64zm284.5-46.6C518.3 135.6 410.9 64 288 64S57.7 135.6 3.5 241.4a32.4 32.4 0 0 0 0 29.2C57.7 376.4 165.1 448 288 448s230.3-71.6 284.5-177.4a32.4 32.4 0 0 0 0-29.2zM288 96a128 128 0 1 1 -128 128A128.1 128.1 0 0 1 288 96zm0 320c-107.4 0-205.5-61.3-256-160a294.8 294.8 0 0 1 129.8-129.3C140.9 153.7 128 187.2 128 224a160 160 0 0 0 320 0c0-36.8-12.9-70.3-33.8-97.3A294.8 294.8 0 0 1 544 256c-50.5 98.7-148.6 160-256 160z"
			/>
		</svg>
	);
};

export default LightEye;
